var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Box",
    { staticClass: "table-wrapper" },
    [
      _c("h3", [
        _c("i", { staticClass: "fas fa-power-off" }),
        _vm._v(" " + _vm._s(_vm.resource("AudienceManager_OverView_Inactive")))
      ]),
      _vm._v(" "),
      _c("DataTable", {
        staticClass: "table table-striped",
        attrs: {
          data: _vm.inactiveAudiences,
          columns: _vm.allColumns,
          options: { refresh: { enabled: true }, filter: { enabled: false } },
          loading: _vm.loading || _vm.loadingAudiences
        },
        on: {
          refresh: function($event) {
            return _vm.$emit("refresh")
          },
          reuse: function($event) {
            return _vm.reuseAudience({
              id: $event.id,
              status: _vm.status.concept
            })
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }